import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fa from 'vuetify/lib/locale/fa';
import en from 'vuetify/es5/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
    rtl: true,
    themes: {
        dark: true,
        light: {
          primary: '#a90003',
          secondary: '#fea91e',
          accent: '#ecf0f1',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        },
        dark: {
          primary: '#02c9b7',
          secondary: '#fea91e',
          accent: '#ecf0f1',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        },
      },
      lang: {
        locales: { fa , en },
        current: 'fa',
      },
      icons: {
        iconfont: 'fa',
      },
});
